import './PoliticaPrivacidade.css'

function PoliticaPrivacidade() {
    return (
        <div className="politica">
            <p className="politica-eyebrow">Legal</p>
            <h1 className="politica-title">Política de Privacidade</h1>
            <p className="politica-updated">Última atualização: 16 de setembro de 2026</p>

            <div className="politica-content">
                <p>
                    Esta política explica quais dados o Planeta Arena (site e aplicativo) coleta, para que usamos
                    essas informações e quais são os seus direitos sobre elas.
                </p>

                <h2>1. Quais dados coletamos</h2>
                <p>Ao criar uma conta e usar o Planeta Arena, coletamos:</p>
                <ul>
                    <li><strong>Dados de cadastro:</strong> nome, email, telefone (opcional), data de nascimento e senha (armazenada de forma criptografada, nunca em texto puro).</li>
                    <li><strong>Identificador do dispositivo:</strong> usado apenas para manter sua sessão segura no aplicativo.</li>
                    <li><strong>Dados de uso da arena:</strong> pontuação, horas jogadas, eliminações, mortes, vitórias e derrotas nas partidas, e carimbos do cartão fidelidade — gerados quando você joga no espaço físico.</li>
                </ul>
                <p>Não coletamos localização, não temos anúncios no aplicativo e não usamos ferramentas de rastreamento de terceiros.</p>

                <h2>2. Como usamos seus dados</h2>
                <ul>
                    <li>Autenticar seu acesso e manter sua conta segura;</li>
                    <li>Exibir seu perfil, posição no ranking e progresso no cartão fidelidade;</li>
                    <li>Confirmar sua presença nas partidas (check-in) no espaço físico;</li>
                    <li>Entrar em contato para agendamento e suporte, quando necessário.</li>
                </ul>

                <h2>3. Compartilhamento de dados</h2>
                <p>
                    Não vendemos nem compartilhamos seus dados pessoais com terceiros para fins de publicidade. Seus
                    dados de jogo (apelido, pontuação, posição no ranking) são visíveis publicamente na tela de
                    ranking do site e do aplicativo, como parte do funcionamento normal da plataforma.
                </p>

                <h2>4. Segurança e armazenamento</h2>
                <p>
                    Sua senha é armazenada com hash criptográfico (bcrypt), nunca em texto puro. O PIN de check-in do
                    aplicativo é protegido pela biometria ou senha do seu próprio celular. Os dados são armazenados em
                    servidores próprios da Planeta Arena e da aplicação local do espaço físico.
                </p>

                <h2>5. Idade mínima</h2>
                <p>
                    O Planeta Arena é destinado a jogadores a partir de 16 anos, condição já informada nas regras de
                    participação nas partidas.
                </p>

                <h2>6. Seus direitos</h2>
                <p>
                    Você pode solicitar a qualquer momento a correção, exportação ou exclusão dos seus dados pessoais,
                    entrando em contato pelos canais abaixo.
                </p>

                <h2>7. Alterações nesta política</h2>
                <p>
                    Podemos atualizar esta política conforme o Planeta Arena evolui (por exemplo, ao adicionar novos
                    recursos como notificações). A data no topo desta página sempre indica a versão mais recente.
                </p>

                <h2>8. Contato</h2>
                <p>
                    Dúvidas sobre privacidade? Fale com a gente pelo WhatsApp informado na tela "Como funciona" do
                    site e do aplicativo, ou pelo email <a href="mailto:planeta-arena@deltabyte.com.br">planeta-arena@deltabyte.com.br</a>.
                </p>
            </div>
        </div>
    )
}

export default PoliticaPrivacidade
